import { render, staticRenderFns } from "./FormStudy.vue?vue&type=template&id=8ee6e64e&"
import script from "./FormStudy.vue?vue&type=script&lang=js&"
export * from "./FormStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports